// extracted by mini-css-extract-plugin
export default {"card_apresentacao":"styles_card_apresentacao__KwrY4","cpf_cnpj":"styles_cpf_cnpj__UQ5o4","debitos":"styles_debitos__-q-mW","propostas":"styles_propostas__zE0AQ"};